/** Referências das quantidades da entidade UnidadeNegocio.
 * Utilizada para metas e projeções de vendas
 */
export interface UnidadeNegocioReferenciaQuantidade {
    id: number,
    nome: string;
}

export const unidadeNegocioReferenciaQuantidadeQuantidade: UnidadeNegocioReferenciaQuantidade = {id: 1, nome: 'Quantidade'};
export const unidadeNegocioReferenciaQuantidadePeso: UnidadeNegocioReferenciaQuantidade = {id: 2, nome: 'Peso'};

export const unidadeNegocioReferenciasQuantidades: UnidadeNegocioReferenciaQuantidade[] = [
    unidadeNegocioReferenciaQuantidadeQuantidade,
    unidadeNegocioReferenciaQuantidadePeso
];
